import type { Components, Theme } from "@mui/material";

export const MuiSkeleton: Components<Theme>["MuiSkeleton"] = {
	defaultProps: {
		variant: "rounded",
	},
	variants: [
		{
			props: { variant: "rounded" },
			style: ({ theme }) => ({
				borderRadius: theme.spacing(2),
			}),
		},
	],
};
